module.exports = __webpack_public_path__ + "static/img/bg5.d6320fb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/report/year2023/bg5.png
// module id = Fray
// module chunks = 0